// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".work-orders-expenses[data-v-107fe7b0]{display:flex;height:100%}.work-orders-expenses__toolbar[data-v-107fe7b0]{min-width:30px;border-right:1px solid #dee2e6;margin-right:5px;display:flex;flex-direction:column;padding-right:5px}.work-orders-expenses__toolbar>button[data-v-107fe7b0]{margin:2px}.work-orders-expenses__grid[data-v-107fe7b0]{width:100%}@media(max-width: 770px){.work-orders-expenses__toolbar>button[data-v-107fe7b0]{padding:.1rem .37rem;font-size:.7rem}}", ""]);
// Exports
module.exports = exports;
